__turbopack_context__.v({
  "className": "ibm_plex_sans_arabic_452e90da-module__32cdXq__className",
});
